export enum NotificationTypeEnum {
  RELEASE_NOTES = 'RELEASE_NOTES',
  INITIAL_TOUR = 'INITIAL_TOUR',
  CONSULTATION_TOUR = 'CONSULTATION_TOUR',
  TEMPLATE_TOUR = 'TEMPLATE_TOUR',
  TELEHEALTH_TOUR = 'TELEHEALTH_TOUR',
}
